import React, { useState } from 'react';
import comingSoonpage from '../../../assets/images/ComingSoon.png'
// import { PMU_STATUS } from './../../../../constants/index';
import './style.scss'

const ComingSoon = (props) => {
    return (
        <div className="coming-soon" style={{marginTop:"130px"}}>
           

<img src={comingSoonpage} />
<p className="coming-soon-text">Application Request Opening Soon</p>

           </div>)
}

export default ComingSoon;